<template>
  <div class="page-auth">
    <div class="w-100 h-100 overflow-auto">
      <div class="row m-0">
        <div class="col-10 col-sm-8 col-md-6 col-lg-4 mx-auto login-form">
          <div class="login-form-header bg-dashboard-dark-1">
            <img src="@/assets/infrasel-logo-white.png" />
            <p class="mb-0 mr-2 font-weight-bold text-white">RESET PASSWORD</p>
          </div>
          <div class="login-form-body bg-dashboard-dark-1">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <div
                  class="
                    input-group-text
                    rounded-0
                    bg-white
                    border-right-0
                    text-muted
                    pr-1
                    border-outline-dark
                    bg-dark-input
                  "
                  :class="{ 'border-danger': errors.password }"
                >
                  <font-awesome-icon :icon="['fa', 'key']" />
                </div>
              </div>
              <input
                type="password"
                class="
                  form-control
                  border-left-0 border-outline-dark
                  bg-dark-input
                  text-white
                "
                :class="{ 'border-danger': errors.password }"
                placeholder="Password"
                @keydown.enter="reset()"
                v-model="models.password"
              />
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <div
                  class="
                    input-group-text
                    rounded-0
                    bg-white
                    border-right-0
                    text-muted
                    pr-1
                    border-outline-dark
                    bg-dark-input
                  "
                  :class="{ 'border-danger': errors.passwordConfirmation }"
                >
                  <font-awesome-icon :icon="['fa', 'key']" />
                </div>
              </div>
              <input
                type="password"
                class="
                  form-control
                  border-left-0 border-outline-dark
                  bg-dark-input
                  text-white
                "
                :class="{ 'border-danger': errors.passwordConfirmation }"
                placeholder="Confirm Password"
                @keydown.enter="reset()"
                v-model="models.passwordConfirmation"
              />
            </div>
            <p class="small text-danger text-center" v-if="resetError">
              {{ errorMessage }}
            </p>
            <button
              class="btn btn-block btn-login btn-primary rounded-0"
              @click="reset()"
              :disabled="isProcessing"
            >
              <span>Reset Password</span>
              <div
                class="spinner-border spinner-border-sm text-light"
                v-if="isProcessing"
              ></div>
            </button>
            <button
              type="button"
              class="btn btn-link w-100 mt-3"
              @click="goTo('auth')"
            >
              Back to login
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      isProcessing: false,
      resetError: false,
      errorMessage: "",
      models: {
        password: "",
        passwordConfirmation: "",
      },
      errors: {
        password: false,
        passwordConfirmation: false,
      },
    };
  },
  methods: {
    reset() {
      this.isProcessing = true;
      const hasError = this.verifyForm();
      if (!hasError) {
        let code = this.$route.query.code;
        API.post("auth/reset-password", {
          code: code, // code contained in the reset link of step 3.
          password: this.models.password,
          passwordConfirmation: this.models.passwordConfirmation,
        })
          .then((res) => {
            this.isProcessing = false;
            // if(res.data){
            Swal.fire({
              title: "Success",
              text: "Your password successfully reset, you can login with your new password",
              icon: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({
                  name: "auth",
                });
              }
            });
            // }
          })
          .catch((err) => {
            let resErr = err.response;

            let msg =
              resErr.data.message && resErr.data.message.length
                ? resErr.data.message[0]
                : "Unable to reset password";

            this.isProcessing = false;
            Swal.fire(
              "",
              msg.messages[0].message
                ? msg.messages[0].message
                : "Unable to reset password",
              "error"
            );
          });
      } else {
        this.isProcessing = false;
      }
    },
    verifyForm() {
      this.resetError = false;
      for (let index = 0; index < Object.keys(this.models).length; index++) {
        const key = Object.keys(this.models)[index];
        const model = this.models[key];

        if (!model) {
          this.errorMessage = "Password and Confirm Password must be filed out";
          this.errors[key] = true;
          this.resetError = true;
        } else if (
          this.models["password"] !== this.models["passwordConfirmation"]
        ) {
          this.errorMessage =
            "Your password and Confirm password do not match.";
          this.errors[key] = true;
          this.resetError = true;
        } else {
          this.errors[key] = false;
        }
      }
      return this.resetError;
    },
    goTo(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>
